import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ImageOrientation } from '@features/trips/components/trips-trip-other-trips-item/trips-trip-other-trips-item.component';
import { Asset } from '@generated/graphql';
import { TripsItineraryGalleryItemComponent } from '../trips-itinerary-gallery-item/trips-itinerary-gallery-item.component';

@Component({
    selector: 'app-trips-itinerary-gallery',
    templateUrl: './trips-itinerary-gallery.component.html',
    imports: [NgClass, TripsItineraryGalleryItemComponent],
})
export class TripsItineraryGalleryComponent implements OnInit {
    @Input() assets: Asset[] = [];
    styles: [string, ImageOrientation][] = [
        ['md:aspect-w-16 md:aspect-h-9 md:col-span-2 md:row-span-2', 'square'],
        ['md:aspect-w-2 md:aspect-h-1 md:col-span-2', 'horizontal'],
        ['md:aspect-w-1 md:aspect-h-1', 'square'],
        ['md:aspect-w-1 md:aspect-h-1', 'square'],
        [
            'md:aspect-w-2 md:aspect-h-1 md:col-span-4 md:row-span-2',
            'horizontal',
        ],
    ];
    constructor() {}

    ngOnInit(): void {
        if (this.assets.length === 3) {
            this.styles[2] = [
                'md:aspect-w-2 md:aspect-h-1 md:col-span-2',
                'horizontal',
            ];
        }
        if (this.assets.length === 2) {
            this.styles[1] = [
                'md:aspect-w-1 md:aspect-h-1 md:col-span-2 md:row-span-2 w-full',
                'square',
            ];
        }
    }
}
